// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"5567":"c8588408","8821":"10541459"}[chunkId] + ".css";
};